import React from 'react';
import './About.css';

const list = [
  'Placement at Top MNCs',
  'Resume & Interview Training',
  'Career Counseling & Coaching',
  'Salary Negotiation Assistance',
  'Mock Interviews',
  'Certification & Internship Support',
  'Training Support For Career Growth',
];

export default function About() {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-text">
            <p className="section-label">About Us</p>
            <h2 className="section-title">Build Your <span>Career</span> With Us</h2>
            <p>Laftek Business Solutions is a career development firm that helps candidates build their careers with placement opportunities, resume and interview skills training, career counseling and coaching, and salary negotiation assistance.</p>
            <p>Our experienced consultants assist at every career stage, from fresh graduates to senior professionals looking for their next big move.</p>
            <p>With mock interviews, training support, certification guidance, and internship placements, we cover every aspect of your career journey.</p>
          </div>
          <div className="about-visual">
            <div className="about-visual-title">What We Offer</div>
            <ul className="about-list">
              {list.map((item) => (
                <li key={item}><span className="check">*</span> {item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
